import { render, staticRenderFns } from "./CampusParams.vue?vue&type=template&id=a395e168&scoped=true&"
import script from "./CampusParams.vue?vue&type=script&lang=ts&"
export * from "./CampusParams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a395e168",
  null
  
)

export default component.exports